import { useGetInfoGenerali } from 'client/api/backend/procedimenti/procedimenti';
import { useMemo } from 'react';
import { mapProcedureNotes } from './mapProcedureNotes';

/**
 * Ritorna le note di completamento di una procedure per tutte le sue attività
 */
export function useProcedureNotes(procedureId: string | undefined) {
  const result = useGetInfoGenerali(procedureId ?? 'unknown', {
    query: { enabled: !!procedureId }
  });
  const notes = useMemo(
    () => mapProcedureNotes(result.data?.data),
    [result.data?.data]
  );

  if (!procedureId) return { loading: false, error: null, notes: [] };

  return {
    loading: result.isLoading,
    error: result.error,
    notes
  };
}
